import React from "react";
import { useStyles } from "./styles";

export const BlocksCards = ({ children, ...props }) => {
  const ref = React.useRef<HTMLDivElement>(null);
  const classes = useStyles(props);

  const cards = React.useMemo(() => children.filter((x) => x.props.role === "blockCard"), [children]);

  return (
    <div className={classes.root} ref={ref}>
      <div className={classes.cards}>{cards}</div>
    </div>
  );
};
BlocksCards.muiName = "BlocksCards";
BlocksCards.displayName = "BlocksCards";

export default BlocksCards;

export * from "./shared/BlockCard";
